import FormCodeEditor from "@babackapp/react-hook-forms-components/form-code-editor";
import FormCountrySelector from "@babackapp/react-hook-forms-components/form-country-selector";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import useTranslation from "@babackapp/translations/use-translation";
import { FormField } from "@babackapp/ui/components/form";
import { useFormContext } from "react-hook-form";
import { StoreFormValues } from "./types";

export default function AddressTab() {
  const t = useTranslation();
  const { control } = useFormContext<StoreFormValues>();

  return (
    <div className="flex flex-col gap-4">
      <FormField
        control={control}
        name="general.address.companyName"
        render={({ field }) => (
          <FormInput
            label={t("settings.shop.physic.fields.companyName.title")}
            {...field}
          />
        )}
      />
      <FormField
        control={control}
        name="general.externalId"
        render={({ field }) => (
          <FormInput
            label={t("settings.shop.physic.fields.externalId.title")}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="general.selectableByUser"
        render={({ field }) => (
          <FormSwitch
            label={t("settings.shop.physic.fields.selectableByUser.title")}
            description={t(
              "settings.shop.physic.fields.selectableByUser.description",
            )}
            {...field}
          />
        )}
      />

      <FormInputRow>
        <FormField
          control={control}
          name="general.address.address1"
          render={({ field }) => (
            <FormInput
              label={t("settings.shop.physic.fields.address1.title")}
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="general.address.address2"
          render={({ field }) => (
            <FormInput
              label={t("settings.shop.physic.fields.address2.title")}
              {...field}
            />
          )}
        />
      </FormInputRow>

      <FormField
        control={control}
        name="general.address.country"
        render={({ field }) => (
          <FormCountrySelector
            label={t("settings.shop.physic.fields.country.title")}
            value={field.value}
            onValueChange={field.onChange}
          />
        )}
      />

      <FormInputRow>
        <FormField
          control={control}
          name="general.address.zip"
          render={({ field }) => (
            <FormInput
              label={t("settings.shop.physic.fields.zip.title")}
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="general.address.city"
          render={({ field }) => (
            <FormInput
              label={t("settings.shop.physic.fields.city.title")}
              {...field}
            />
          )}
        />
      </FormInputRow>

      <FormField
        control={control}
        name="general.embedMap"
        render={({ field }) => (
          <FormCodeEditor
            label={t("settings.shop.physic.fields.urlEmbedMap.title")}
            language="html"
            value={field.value ?? ""}
            onChange={field.onChange}
          />
        )}
      />
      <FormField
        control={control}
        name="general.urlMap"
        render={({ field }) => (
          <FormInput
            label={t("settings.shop.physic.fields.urlMap.title")}
            {...field}
          />
        )}
      />
    </div>
  );
}
